import React, { useContext, useRef, useState } from 'react';

import { Spinner } from 'Redesign_Funnel/components/Loading';

import { LoadingProvider, loadingContext } from './GlobalLoading.utils';
import { GlobalLoadingWrapper } from './GlobalLoading.styles';
import { ContentType } from './GlobalLoading.models';

export const LOADING_DELAY = 250;

export const GlobalLoading: React.FC = () => {
  const { isLoading, content } = useContext(loadingContext);

  const { Component, props } = content || { Component: undefined, props: undefined };

  return isLoading ? (
    <GlobalLoadingWrapper aria-label="Cargando...">
      <Spinner />
      {Component ? <Component {...props} /> : <></>}
    </GlobalLoadingWrapper>
  ) : null;
};

export const GlobalLoadingProvider: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState<ContentType<object>>();
  const timer = useRef<Record<string, ReturnType<typeof setTimeout>>>({});
  const loadingQueueRef = useRef(new Set<string>());
  const startLoading = (loadingId: readonly unknown[] | string = 'unknown') => {
    const stringLoadingId = typeof loadingId === 'string' ? loadingId : loadingId.join('-');
    clearTimeout(timer.current[stringLoadingId]);

    if (loadingQueueRef.current.has(stringLoadingId)) return;
    loadingQueueRef.current.add(stringLoadingId);
    setIsLoading(loadingQueueRef.current.size > 0);
  };
  const endLoading = (loadingId: readonly unknown[] | string = 'unknown') => {
    const stringLoadingId = typeof loadingId === 'string' ? loadingId : loadingId.join('-');
    clearTimeout(timer.current[stringLoadingId]);

    if (!loadingQueueRef.current.has(stringLoadingId)) return;

    timer.current[stringLoadingId] = setTimeout(() => {
      loadingQueueRef.current.delete(stringLoadingId);
      setIsLoading(loadingQueueRef.current.size > 0);
    }, LOADING_DELAY);
  };

  return (
    <LoadingProvider value={{
      content,
      endLoading,
      isLoading,
      loadingQueueRef,
      setContent,
      startLoading,
    }}
    >
      {children}
    </LoadingProvider>
  );
};

